import { combineReducers } from 'redux';
import { carPolicyDetailsReducer } from './CarPolicyDetails';
import { cancerPolicyDetailsReducer } from './CancerPolicyDetails';
import { healthPolicyDetailsReducer } from './HealthPolicyDetails';
import { personalAccidentPolicyDetailsReducer } from './PersonalAccidentPolicyDetails';

export default combineReducers({
  carPolicyDetailsReducer,
  cancerPolicyDetailsReducer,
  healthPolicyDetailsReducer,
  personalAccidentPolicyDetailsReducer,
});
